$(document).ready(function() {
    if ($('.module__cards__list .card__description a').length > 0) {
        $('.module__cards__list .card__description a').append('<i class="fas fa-arrow-right"></i>');
    }
});